import styles from "@styles/BaseCurrencyInput.module.css";
import React from "react";

import classNames from "classnames/bind";
import { If } from "../control-statements";
import CurrencyInput from "./index";
const css = classNames.bind(styles);

export class BaseCurrencyInput extends React.Component {
  static defaultProps = {
    precision: 2,
    prefix: "R$ ",
    decimalSeparator: ",",
    thousandSeparator: ".",
    valid: true,
  };

  render() {
    const {
      label: labelText,
      placeholder,
      onChange,
      mask,
      design = "one",
      id,
      value,
      disabled,
      allowEmpty = false,
      readOnly,
    } = this.props;
    const {
      precision,
      prefix,
      decimalSeparator,
      thousandSeparator,
      valid,
      suffix,
      className,
      max,
    } = this.props;
    const { onBlur, onFocus, onEnter } = this.props;

    return (
      <div
        className={css({
          input: true,
          [className]: className,
        })}
      >
        <div
          className={css({
            "label-float": true,
            placeholder: placeholder,
            invalid: !valid,
          })}
        >
          <CurrencyInput
            value={value || null}
            decimalSeparator={decimalSeparator}
            thousandSeparator={thousandSeparator}
            precision={precision}
            prefix={prefix}
            suffix={suffix}
            className={css({
              [`design-${design}`]: true,
              disabled: disabled,
            })}
            id={id}
            inputType={"tel"}
            placeholder={placeholder ? placeholder : labelText}
            maxLength={max}
            onFocus={onFocus}
            onBlur={onBlur}
            onKeyUp={(key) => {
              key.key === "Enter" && onEnter && onEnter();
              return true;
            }}
            onChangeEvent={(e, maskedvalue, floatvalue) => {
              // console.log(typeof value == "number");
              // console.log(e.target.value, maskedvalue, floatvalue);
              onChange && onChange(floatvalue);
            }}
            readOnly={readOnly}
          />
          <If cond={!placeholder}>
            <label htmlFor={id}>{labelText}</label>
          </If>
        </div>
      </div>
    );
  }
}
